<div class="spinner" *ngIf="loading">
    <mat-spinner></mat-spinner>
</div>